import { composeIO } from 'react-compose-io'
import { SelecaoParceiroExecucaoCicloView } from './SelecaoParceiroExecucaoCiclo.View'
import { selecaoParceiroExecucaoCicloIO } from './SelecaoParceiroExecucaoCiclo.IO'

export const SelecaoParceiroExecucaoCiclo = composeIO(SelecaoParceiroExecucaoCicloView, selecaoParceiroExecucaoCicloIO)
